import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useAuth } from '../../contexts/AuthContext';

function Login() {
  const { user, signIn, loading, error } = useAuth();
  const [signingIn, setSigningIn] = React.useState(false);

  // Redirect authenticated users away from login page
  if (user && !loading) {
    return <Navigate to="/" replace />;
  }

  const handleSignIn = async () => {
    setSigningIn(true);
    try {
      await signIn();
    } catch (err) {
      // Error is handled in AuthContext
    } finally {
      setSigningIn(false);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Card sx={{ maxWidth: 400, width: '100%', mx: 2 }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
            Analytics Dashboard
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            FDA CRL Analysis & Insider Trading Monitor
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
              {error}
            </Alert>
          )}

          <Button
            variant="contained"
            size="large"
            startIcon={signingIn ? <CircularProgress size={20} color="inherit" /> : <GoogleIcon />}
            onClick={handleSignIn}
            disabled={signingIn}
            fullWidth
            sx={{ py: 1.5 }}
          >
            {signingIn ? 'Signing in...' : 'Sign in with Google'}
          </Button>

          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
            Access restricted to authorized users only
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

export default Login;
